import { LOAD_INVITATION, UPDATE_INVITATION} from '../actions/types';

const initialState = {
    data: null,
    loaded: false,
};

export default function (state = initialState, action) {

  const { payload, type } = action

  switch (type) {
    case LOAD_INVITATION:
      return {
        ...state,
        data: payload,
        loaded: true
      };

    case UPDATE_INVITATION:
      return {
        ...state,
        data: payload,
      };

    default:
      return state;
  }
}
